import axios from 'axios';
import { apiURL } from '@/config';
const jwtDecode = require('jwt-decode')

export async function registerUser(data) {
    return await axios.post(apiURL + 'register', data, {
        responseType: 'json',
    })
}

export async function login(data) {
    return await axios.post(apiURL + 'login', data, {
        responseType: 'json',
    })
}

export async function userData() {
    return await axios.get(apiURL + 'me', {
        responseType: 'json',
    })
}

export async function updateUserData(data) {
    return await axios.put(apiURL + 'me', data, {
        responseType: 'json',
    });
}

export function successLogin(token) {
    const data = jwtDecode(token);
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(data));
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
}

export function logout() {
    axios.defaults.headers.common['Authorization'] = '';
    localStorage.removeItem('user');
    localStorage.removeItem('userData');
    localStorage.removeItem('token');
}

export function logged() {
    const user = JSON.parse(localStorage.getItem('user'));
    return user && user['roles'].length > 0;
}

export async function requestPassword(data) {
    return await axios.put(apiURL + 'request-password-reset', data, {
        responseType: 'json',
    })
}

export async function resetPassword(token, data) {
    return await axios.put(apiURL + 'password-reset/' + token, data, {
        responseType: 'json',
    })
}
